import { AppUserCompanyAccessType } from '../models/enums/appUserCompanyAccessType.enum';

/**
 * Maps a company-form tab id (as passed to `<app-tab-toolbar [tabId]>` and used as the key in
 * `CompanyFormComponent.visibleTabs`) to the access type that grants it.
 *
 * Keep in sync with the tab ids in company-form.component.html — a tab id missing from this map
 * resolves to no access type, which leaves the tab editable.
 */
export const COMPANY_TAB_ACCESS_TYPES: Record<string, AppUserCompanyAccessType> = {
  details: AppUserCompanyAccessType.Details,
  collection: AppUserCompanyAccessType.Collection,
  audit1: AppUserCompanyAccessType.Audit1,
  audit2: AppUserCompanyAccessType.Audit2,
  board: AppUserCompanyAccessType.Board,
  committees: AppUserCompanyAccessType.Committees,
  ownership: AppUserCompanyAccessType.Ownership,
  family: AppUserCompanyAccessType.Family,
  salary1: AppUserCompanyAccessType.Salary1,
  salary2: AppUserCompanyAccessType.Salary2,
  accounting: AppUserCompanyAccessType.Accounting,
  society: AppUserCompanyAccessType.Society,
  employees: AppUserCompanyAccessType.Employees,
  energyWater: AppUserCompanyAccessType.EnergyWater,
  emissionsWaste: AppUserCompanyAccessType.EmissionsWaste,
  votingResults: AppUserCompanyAccessType.VotingResults,
  messages: AppUserCompanyAccessType.Messages,
  process: AppUserCompanyAccessType.Process
};

export function getCompanyTabAccessType(tabId: string | null): AppUserCompanyAccessType | null {
  return tabId ? COMPANY_TAB_ACCESS_TYPES[tabId] ?? null : null;
}
